import React from "react";
import { graphql, Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Seo from "../components/Seo";
import { getBlogPath } from "../utils/blogRoutes";
import "../../scss/main.scss";
import "../../scss/_blog.scss";

export default function AuthorPage({ data }) {
	const { ghostAuthor: author, allGhostPost: posts } = data;
	const authorPath = `/authors/${author.slug}/`;
	const description = author.bio || `Advice and practical live-in care guidance written by ${author.name} at Edyn Care.`;
	const personSchema = {
		"@context": "https://schema.org",
		"@type": "Person",
		"@id": `https://www.edyn.care${authorPath}#person`,
		name: author.name,
		description,
		url: `https://www.edyn.care${authorPath}`,
		worksFor: { "@id": "https://www.edyn.care/#organisation" },
	};

	return (
		<>
			<Seo
				title={`${author.name}, Advice Author | Edyn Care`}
				description={description}
				path={authorPath}
				breadcrumbs={[
					{ name: "Home", path: "/" },
					{ name: "Advice", path: "/blog/" },
					{ name: author.name, path: authorPath },
				]}
			>
				<script type="application/ld+json">{JSON.stringify(personSchema)}</script>
			</Seo>
			<div className="container edyn-commercial-shell edyn-author-shell">
				<Header />
				<main id="main-content" className="author-page">
					<section className="author-page__hero">
						<div className="site-shell author-page__hero-grid">
							{author.profile_image_sharp && (
								<GatsbyImage image={getImage(author.profile_image_sharp)} alt={`${author.name}, Edyn Care advice author`} />
							)}
							<div>
								<p className="eyebrow eyebrow--light">Edyn advice author</p>
								<h1>{author.name}</h1>
								<p>{description}</p>
							</div>
						</div>
					</section>
					<section className="author-page__articles section-space">
						<div className="site-shell">
							<p className="eyebrow">Written by {author.name}</p>
							<h2>Practical care guides</h2>
							<ul>
								{posts.nodes.map((post) => (
									<li key={post.slug}>
										<Link to={getBlogPath(post.slug)}>
											<span>{post.published_at}</span>
											<strong>{post.title}</strong>
											<i aria-hidden="true">&#8594;</i>
										</Link>
									</li>
								))}
							</ul>
						</div>
					</section>
				</main>
				<Footer />
			</div>
		</>
	);
}

export const pageQuery = graphql`
	query($slug: String!) {
		ghostAuthor(slug: { eq: $slug }) {
			name
			slug
			bio
			profile_image_sharp {
				childImageSharp { gatsbyImageData(width: 420, placeholder: BLURRED) }
			}
		}
		allGhostPost(
			filter: { primary_author: { slug: { eq: $slug } } }
			sort: { order: DESC, fields: [published_at] }
		) {
			nodes {
				title
				slug
				published_at(formatString: "DD MMM YYYY")
			}
		}
	}
`;
